<script>
  import { teamSection } from './team.js';
</script>

<section id="team" class="team-section" aria-labelledby="team-title">
  <div class="team-inner">
    <div class="team-content">
      <div class="team-head">
        <h2 id="team-title">{teamSection.title}</h2>
        <div class="section-line" aria-hidden="true"></div>
        <p>{teamSection.description}</p>
      </div>

      <div class="team-grid" aria-label="Команда форума">
        {#each teamSection.members as member}
          <article class="team-member" style={`--mobile-order: ${member.mobileOrder}`}>
            <span class="member-photo-frame">
              <img
                class="member-photo"
                src={member.imageSrc}
                alt={member.name}
                style={`object-position: ${member.imagePosition}; --image-width: ${member.imageWidth ?? '100%'}; --image-height: ${member.imageHeight ?? '100%'}; --image-left: ${member.imageLeft ?? '0'}; --image-top: ${member.imageTop ?? '0'}`}
              />
            </span>
            <div class="member-copy">
              <h3>{member.name}</h3>
              <p class="member-role">{member.role}</p>
              {#if member.companyHref}
                <a class="member-company" href={member.companyHref} target="_blank" rel="noreferrer">{member.company}</a>
              {:else}
                <p class="member-company">{member.company}</p>
              {/if}
            </div>
          </article>
        {/each}
      </div>
    </div>
  </div>
</section>

<style>
  .team-section {
    display: flex;
    justify-content: center;
    padding: 100px 0;
    background: #000000;
    color: #ffffff;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-variation-settings: 'wdth' 100;
  }

  .team-inner {
    display: flex;
    width: min(100%, 1440px);
    justify-content: center;
    padding: 0 64px;
    box-sizing: border-box;
  }

  .team-content {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 56px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .team-head {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 21px;
    padding-bottom: 48px;
    box-sizing: border-box;
  }

  h2,
  h3,
  p {
    margin: 0;
  }

  h2 {
    color: #ffffff;
    font-size: 56px;
    font-weight: 700;
    line-height: 56px;
    text-transform: uppercase;
  }

  .section-line {
    width: 78px;
    height: 4px;
    background: #e7b962;
  }

  .team-head p {
    color: rgba(255, 255, 255, 0.5);
    font-size: 24px;
    font-weight: 300;
    line-height: 36px;
  }

  .team-grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 64px 32px;
  }

  .team-member {
    display: flex;
    min-width: 0;
    align-items: flex-start;
    gap: 24px;
  }

  .member-photo-frame {
    position: relative;
    width: 96px;
    height: 96px;
    flex: 0 0 96px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 18px;
    background: #111111;
    box-sizing: border-box;
  }

  .member-photo {
    position: absolute;
    left: var(--image-left);
    top: var(--image-top);
    width: var(--image-width);
    height: var(--image-height);
    max-width: none;
    border-radius: 18px;
    object-fit: cover;
  }

  .member-copy {
    display: flex;
    min-width: 0;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    padding-top: 3px;
  }

  h3 {
    color: #ffffff;
    font-size: 24px;
    font-weight: 500;
    line-height: normal;
  }

  .member-role {
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-transform: uppercase;
  }

  .member-company {
    color: #e7b962;
    font-size: 16px;
    font-weight: 300;
    line-height: 16px;
    text-decoration: none;
    transition: color 160ms ease;
  }

  a.member-company:hover,
  a.member-company:focus-visible {
    color: #ffffff;
  }

  @media (max-width: 1279px) {
    .team-inner {
      padding: 0 32px;
    }

    .team-content {
      padding: 0 12px;
    }

    .team-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    h2 {
      font-size: 40px;
      line-height: 1.1;
    }
  }

  @media (max-width: 1599px) and (min-width: 1280px) {
    h2 {
      font-size: 48px;
      line-height: 1.1;
    }
  }

  @media (max-width: 767px) {
    .team-section {
      padding: 40px 0;
    }

    .team-inner {
      padding: 0 24px;
    }

    .team-content {
      gap: 56px;
      padding: 0;
    }

    .team-head {
      padding-bottom: 48px;
    }

    h2 {
      font-size: 32px;
      line-height: normal;
    }

    .team-head p {
      max-width: 310px;
      font-size: 18px;
      font-weight: 400;
      line-height: normal;
    }

    .team-grid {
      display: flex;
      flex-direction: column;
      gap: 36px;
    }

    .team-member {
      order: var(--mobile-order);
      align-items: center;
    }

    .member-photo-frame {
      width: 80px;
      height: 80px;
      flex-basis: 80px;
    }

    h3 {
      font-size: 18px;
    }

    .member-role,
    .member-company {
      font-size: 14px;
      line-height: normal;
    }
  }
</style>
